require('bootstrap/dist/css/bootstrap.css');
require('font-awesome/css/font-awesome.css');
require('./less/content.less');
require('./less/hamburg.less');
require('./less/header.less');
require('./less/loading.less');
require('./less/main.less');
require('./less/mixins.less');
require('./less/sidebar.less');
require('./less/variables.less');
require('./less/widgets.less');


var top_level_tpl = require('./templates/top_level.html');
var sidebar_tpl = require('./templates/sidebar.html');
var content_header_tpl = require('./templates/content_header.html');

export default function(app){
    var app_deps = [
        require('./controllers/master-ctrl'),
        require('./controllers/alert-ctrl'),
        require('./directives/loading'),
        require('./directives/widget'),
        require('./directives/widget-body'),
        require('./directives/widget-footer'),
        require('./directives/widget-header'),
    ];
    app_deps.forEach(x => x.default(app));

    app.config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider){
        $stateProvider
            .state('layout', {
                abstract: true,
                template: top_level_tpl,
                controller: 'MasterCtrl',
                resolve: {
                    current_user_info: ['CurrentUserApiService', function(CurrentUserApiService) {
                        return CurrentUserApiService.info({})
                    }]
                  }
            })
            .state('amt', {
                'parent':'layout',
                'abstract': true,
                'views': {
                    'sidebar': {'template': sidebar_tpl},
                    'content-header': {'template': content_header_tpl},
                    '': {'template': '<div ui-view></div>'}
                },
            })
        .state("amt.not_found", {
            url: "/not_found",
            template: "<h2>Page Not Found</h2>",
            data: {
                menu_title: "Page Not Found"
            }
        });
        $urlRouterProvider.otherwise(function ($injector, $location) {
            var $state = $injector.get('$state');

            $state.go("amt.not_found", {
                title: "Page not found",
                message: 'Could not find a state associated with url "'+$location.$$url+'"'
            });
        });
        $urlRouterProvider.otherwise('/not_found');

    }]);
    app.run(['$state', '$rootScope', function($state, $rootScope){
        $rootScope.$menu = [];
        $rootScope.$menu_top = [];
        $rootScope.$menu_filter = undefined;
        var states = $state.get();
        for(var i in states){
            var state = states[i];

            if(!state.menu)
                continue;

            var state_data = state.data;
            if (!state_data){
                console.warn(state.name + " has empty data")
            }

            var menu = state.menu;

            if(!state_data.hasOwnProperty('title')){
                console.warn(state.name + " has not valid menu data, title not exists")
            }

            menu.role = state_data.role || 'any';
            menu.state = state.name;
            menu.title = state_data.title;
            menu.abstract = state.abstract;
            menu.priority = state_data.priority || -1;

            if(menu.childs_auto){
                var childs = states.filter(function (t) { return t.name.indexOf(state.name) === 0 });
                menu.childs = [];
                for (var i = 0; i < childs.length; i++) {
                    var child = childs[i];
                    if(child.name.replace(state.name + '.', '').split('.').length == 1){
                        menu.childs.push({state: child.name})
                    }
                }
            }

            if(menu.childs instanceof Array){
                for(var j in menu.childs){
                    var child = menu.childs[j];
                    var child_state = $state.get(child.state);
                    if (!child_state){
                        console.warn(child.state + " not found");
                        delete menu.childs[j];
                        continue;
                    }
                    var child_state_data = child_state.data;
                    if (!child_state_data){
                        console.warn(child.state + " has empty data");
                        delete menu.childs[j];
                        continue;
                    }

                    child.role = child_state_data.role;
                    child.title = child_state_data.title;
                    child.priority = child_state_data.priority || -1
                }
            }
            if(menu.position == 'top'){
                $rootScope.$menu_top.push(menu)
            }else{
                $rootScope.$menu.push(menu)
            }
        }

        $rootScope.is_menu_collapsed = true;
        $rootScope.toggle_menu_collapse = function() {
            $rootScope.is_menu_collapsed = !$rootScope.is_menu_collapsed;
            $rootScope.$menu.forEach(menu_item => menu_item.is_collapsed = $rootScope.is_menu_collapsed);
        }

        $rootScope.$menu_storage = [...$rootScope.$menu];
        $rootScope.filter_menu = function(filter_value) {
            if (filter_value === undefined || filter_value === '') {
                $rootScope.$menu_filter = undefined;
                $rootScope.$menu = [...$rootScope.$menu_storage];
                $rootScope.$menu.forEach(menu_item => menu_item.is_collapsed = true);
                return;
            }
            let filtered_menu = [];
            const filter_lowered = filter_value.toLowerCase();
            for (let menu_item of $rootScope.$menu_storage) {
                const menu_item_lowered = menu_item.title.toLowerCase();
                if (menu_item_lowered.includes(filter_lowered)) {
                    menu_item.is_collapsed = false;
                    filtered_menu.push(menu_item);
                }
                else if (Array.isArray(menu_item.childs)) {
                    let filtered_childs = [];
                    for (let sub_menu_item of menu_item.childs) {
                        const sub_menu_item_lowered = sub_menu_item.title.toLowerCase();
                        if (sub_menu_item_lowered.includes(filter_lowered)) {
                            filtered_childs.push(sub_menu_item);
                        }
                    }
                    if (filtered_childs.length > 0) {
                        const menu_item_clone = structuredClone(menu_item);
                        menu_item_clone.childs = filtered_childs;
                        menu_item_clone.is_collapsed = false;
                        filtered_menu.push(menu_item_clone);
                    }
                }
            }
            $rootScope.$menu = filtered_menu;
        }
    }])
};
